import styled from "styled-components"
import React from "react"
import { Overlay, Popover } from "react-bootstrap"
import { Placement } from "react-bootstrap/esm/types"

// without arrow
const PopoverSimple = styled.div<{
    placement: Placement
}>`
    position: absolute;
    z-index: 1000;
    min-width: 180px;
    border: none;
    border-radius: 2px;
    padding: 0;
    color: ${(props) => props.theme.popupMenuColor};
    background: ${(props) => props.theme.popupMenuBackground};

    ${(props) => props.placement && `
        box-shadow: ${
    (props.placement.indexOf("left") === 0) ? props.theme.popupMenuBoxShadowLeft
        : (props.placement.indexOf("right") === 0) ? props.theme.popupMenuBoxShadowRight
            : (props.placement.indexOf("bottom") === 0) ? props.theme.popupMenuBoxShadowBottom
                : (props.placement.indexOf("top") === 0) ? props.theme.popupMenuBoxShadowTop
                    : "none"
};
    `}
`

// with arrow
const PopoverStyled = styled(Popover)<{
    placement: Placement
}>`
    min-width: 180px;
    background: ${(props) => props.theme.popupMenuBackground};
    box-shadow: ${(props) => props.theme.popupMenuBoxShadow};
    border: 1px solid ${(props) => props.theme.popupMenuBackground};
    border-radius: 2px;

    ${(props) => props.placement && `
        & > .popover-arrow::before,
        & > .popover-arrow::after {
            border-left-color: ${props.placement.indexOf("left") === 0 ? props.theme.popupMenuBackground : "transparent"};
            border-right-color: ${props.placement.indexOf("right") === 0 ? props.theme.popupMenuBackground : "transparent"};
            border-bottom-color: ${props.placement.indexOf("bottom") === 0 ? props.theme.popupMenuBackground : "transparent"};
            border-top-color: ${props.placement.indexOf("top") === 0 ? props.theme.popupMenuBackground : "transparent"};
            border-width: ${
    (props.placement.indexOf("left") === 0) ? "8px 0 8px 8px"
        : (props.placement.indexOf("right") === 0) ? "8px 8px 8px 0"
            : (props.placement.indexOf("bottom") === 0) ? "0 8px 8px 8px"
                : (props.placement.indexOf("top") === 0) ? "8px 8px 0 8px"
                    : "0"
};
        }
    `}
`
const PopoverContentStyled = styled(Popover.Body)`
    padding: 0;
    color: ${(props) => props.theme.popupMenuColor};
`

export const PopupMenuItem = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 36px;
    min-width: 100px;
    padding: 0 15px;
    cursor: pointer;
    white-space: nowrap;
    color: ${(props) => props.theme.popupMenuColor};

    &:hover {
        background: ${(props) => props.theme.popupMenuBackgroundHover};
    }

    & > input[type="file"] {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
`

interface PopupMenuProps {
    show: boolean
    target: HTMLElement
    placement: Placement
    showArrow?: boolean
    children: JSX.Element[]
}

export const PopupMenu = ({
    show,
    target,
    placement,
    showArrow = true,
    children,
}: PopupMenuProps) => (
    <Overlay
        show={show}
        target={target}
        placement={placement}
    >
        {
            showArrow ? (
                <PopoverStyled placement={placement}>
                    <PopoverContentStyled>
                        { children }
                    </PopoverContentStyled>
                </PopoverStyled>
            ) : (
                <PopoverSimple placement={placement}>
                    { children }
                </PopoverSimple>
            )
        }
    </Overlay>
)
